export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./matchList.vue?vue&type=template&id=30794c8f&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/match/matchList.vue?vue&type=template&id=30794c8f&scoped=true&
// module id = null
// module chunks = 